import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd99cc9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-exam-container"
}
const _hoisted_2 = { class: "user-exam-header-outer-container" }
const _hoisted_3 = { class: "user-exam-body-outer-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserExamHeader = _resolveComponent("UserExamHeader")!
  const _component_UserExamBody = _resolveComponent("UserExamBody")!
  const _component_CheatMask = _resolveComponent("CheatMask")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UserExamHeader)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UserExamBody)
        ]),
        (!_ctx.examService.answerMode && !_ctx.hideCheatMask)
          ? (_openBlock(), _createBlock(_component_CheatMask, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}